import "./Home.module.css";
import EnTete from "@/reusable_sections/Header";
import HeroBilingue from "./sections/HeroBilingue";
import NosPiliers from "./sections/NosPiliers";
import NotreApproche from "./sections/NotreApproche";
import VisionMission from "./sections/VisionMission";
import ContactUs from "./sections/ContactUs";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <EnTete />
      <HeroBilingue />
      <NosPiliers />
      <NotreApproche />
      <VisionMission />
      <ContactUs />
      <Footer />
    </div>;
}